/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

export * from "./CrossLocationOpenShiftDataService";
export * from "./ICrossLocationOpenShiftDataService";
